export default __webpack_public_path__ + "static/media/entertainment.5e240002.svg";